import { BrowserRouter, useLocation } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { CartProvider } from "./hooks/useCart";
import Navbar from "./components/feature/Navbar";
import Footer from "./components/feature/Footer";
import FloatingWhatsApp from "./components/feature/FloatingWhatsApp";
import BackToTop from "./components/feature/BackToTop";
import ScrollProgress from "./components/feature/ScrollProgress";
import Loader from "./components/feature/Loader";

function AppLayout() {
  const location = useLocation();
  const isCardapio = location.pathname.startsWith('/cardapio');

  return (
    <>
      <Loader />
      <ScrollProgress />
      {!isCardapio && <Navbar />}
      <AppRoutes />
      <Footer />
      <FloatingWhatsApp />
      <BackToTop />
    </>
  );
}

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <CartProvider>
          <AppLayout />
        </CartProvider>
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;